import styled from '@emotion/styled'
import { IconButton, TextField } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const SummaryContainer = styled.div<{ isEditing: boolean }>`
  background-color: ${({ isEditing }) =>
    isEditing ? '#faf8f5' : 'rgb(232, 243, 255, 50%)'};
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  padding: 24px;
  position: relative;
`

export const EditButton = styled(IconButton)`
  position: absolute;
  top: 40px;
  right: 40px;
  background-color: ${colors.common.white};
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid ${colors.primary.main};

  &:hover {
    background-color: #d5d5d5;
  }

  & .MuiSvgIcon-root {
    font-size: 20px;
    color: ${colors.primary.main};
  }
`

export const SummaryText = styled.p`
  ${typography.baseline.regularSans}
  color: #333;
  margin: 0;
  max-width: calc(100% - 80px);
  padding: 16px;
  &:after {
    content: '';
    display: inline-block;
  }
`

export const InstructionText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: ${colors.text.secondary};
  margin: 0 0 16px 0;
`

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin-top: 8px;

  .MuiOutlinedInput-root {
    min-height: 120px;
  }

  textarea {
    ${typography.baseline.regularSans}
    color: #333;
  }
  fieldset {
    border: none !important;
  }
`
